import { render, staticRenderFns } from "./BrainExercises.vue?vue&type=template&id=56b1bd11"
import script from "./BrainExercises.vue?vue&type=script&lang=js"
export * from "./BrainExercises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports